import en from './en';

export default {
	...en,
	aboutThisRoom: 'Over deze kamer',
	address: 'Adres',
	allEvents: 'Alle evenementen',
	allNews: 'Alle nieuwsberichten',
	allPackages: 'Alle arrangementen',
	archive: 'Archief',
	bookNow: 'Boek nu',
	bookThisPackage: 'Boek dit arrangement',
	bookThisRoom: 'Boek deze kamer',
	buttonMakeReservation: 'Maak een reservering',
	buttonMenu: 'Menu',
	buttonReturnToOverview: 'Terug naar het overzicht',
	buttonRequestInfo: 'Informatie aanvragen',
	checkAvailability: 'Controleer beschikbaarheid',
	contact: 'Contact',
	contactFormHeader: 'Stuur ons een bericht',
	contactUserEmailContent: 'Bedankt voor het invullen van het formulier. Wij zullen spoedig contact met u opnemen.',
	contactUserEmailContentOutro: 'U heeft de volgende gegevens ingevuld:',
	dateFormatShort: '%d-%m-%Y',
	emailFormContactClientSubject: 'Aanvraagformulier ingevuld',
	emailFormContactUserSubject: 'Bedankt voor uw aanvraag',
	emailFormMeetingClientSubject: 'Aanvraagformulier ingevuld',
	emailFormMeetingUserSubject: 'Bedankt voor uw aanvraag',
	exploreOurHotel: 'Ontdek ons hotel',
	facilities: 'Faciliteiten',
	faqDifferentQuestion: 'Ik heb een andere vraag',
	formArrival: 'Aankomst',
	formBlock: 'Blok',
	formCarre: 'Carré',
	formCompanyName: 'Bedrijfsnaam',
	formConsent: 'Ja, ik ga akkoord om berichten te ontvangen. Geef toestemming door het vakje aan te vinken.',
	formDeparture: 'Vertrek',
	formDinner: 'Diner',
	formEmail: 'E-mailadres',
	formEventDate: 'Datum bijeenkomst',
	formEventDateToBeDetermined: 'Datum nader te bepalen',
	formEventType: 'Type bijeenkomst',
	formGeneralErrorCaptcha: 'reCAPTCHA ongeldig',
	formGeneralErrorAkismet: `Dit e-mailadres of IP adres staat geregistreerd voor spam. Graag ontvangen wij uw bericht rechtstreeks via het e-mailadres op deze pagina.`,
	formMeeting: 'Vergadering',
	formMeetingroomID: 'Gewenste ruimte',
	formMeetingroomSetup: 'Zaalopstelling',
	formMessage: 'Bericht',
	formName: 'Naam',
	formNoPreference: 'Geen voorkeur',
	formOtherSpecify: 'Anders, namelijk:',
	formOutdoor: 'Outdoor event',
	formPageID: 'Gewenst arrangement',
	formPax: 'Aantal personen',
	formPhone: 'Telefoonnummer',
	formReception: 'Receptie',
	formSchool: 'School',
	formSubmit: 'Versturen',
	formTheatre: 'Theater',
	formTraining: 'Training',
	formUShape: 'U-vorm',
	highlightsHeader: 'Kies een categorie',
	moreEvents: 'Meer events',
	moreNews: 'Verder lezen',
	moreReviews: 'Meer reviews',
	packageFrom: 'Vanaf',
	perPerson: 'per persoon',
	quickLinks: 'Links',
	ratingOutOf10: ' uit 10',
	readMore: 'Meer lezen',
	reviews: 'Review',
	shareThisPost: 'Delen',
	showAll: 'Toon alles',
	upcomingEvents: 'Upcoming',
	viewThisEvent: 'Verder lezen',
	viewThisPackage: 'Bekijk dit arrangement',
	viewThisRoom: 'Bekijk deze kamer',
};
